<script>
import TheCircleProgressContract from "./TheCircleProgressContract.vue";
import TheDropdownListContractError from "./TheDropdownListContractError.vue";
import EffContractTeacherDataList from "./EffContractTeacherDataList.vue";
import EffContractTeacherActionDataCard from "./EffContractTeacherActionDataCard.vue";
import {mapActions, mapGetters, mapState} from "vuex";
import CheckContractServices from "../../../services/CheckContract.services";
import TheShippingAlertDialog from "../../../Dialog/TheShippingAlertDialog.vue";

export default {
  name: "EffContractTeacherDataCard",
  components: {
    TheShippingAlertDialog,
    EffContractTeacherActionDataCard,
    EffContractTeacherDataList,
    TheDropdownListContractError,
    TheCircleProgressContract,
  },

  data() {
    return {
      showShippingAlert: false,
      loadingBtnCalculate: false,
    }
  },

  computed: {
    ...mapState({
      effConOrder: state => state.effective_contract.payloadOrder,
      dataEmployee: state => state.effective_contract.dataEmployee,
      personEffContracts: state => state.effective_contract.personEffContracts,
    }),

    isNotMobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    ...mapGetters({
      listBasicBidContract: "effective_contract/listBasicBidContract",
      listBasicDeanContract: "effective_contract/listBasicDeanContract",
      listBasicHeadDepartmentContract: "effective_contract/listBasicHeadDepartmentContract",

      listPersonBasicBidContract: "effective_contract/listPersonBasicBidContract",
      listPersonBasicDeanContract: "effective_contract/listPersonBasicDeanContract",
      listPersonBasicHeadDepartmentContract: "effective_contract/listPersonBasicHeadDepartmentContract",

      checkBasicBid: "effective_contract/checkBasicBid",
      checkBasicHeadDepartment: "effective_contract/checkBasicHeadDepartment",
      checkBasicDean: "effective_contract/checkBasicDean",

      isDean: "effective_contract/isDean",
      isHeadDepartment: "effective_contract/isHeadDepartment"
    }),

    bidBasicProgress() {
      if (this.listBasicBidContract.length === 0 && this.listPersonBasicBidContract.length === 0) return 0

      const countContracts = this.listBasicBidContract.length;
      const countPersonContracts = CheckContractServices.listContracts(this.listPersonBasicBidContract, this.listBasicBidContract).length;
      if (countPersonContracts === 0) {
        return 100;
      }
      return (100 - (countPersonContracts/(countContracts / 100))).toFixed(2);
    },

    headDepartmentBasicProgress() {
      if (!this.effConOrder.head_department) return 100
      if (
        this.listBasicHeadDepartmentContract.length === 0
        && this.listPersonBasicHeadDepartmentContract.length === 0
      ) return 0

      const countContracts = this.listBasicHeadDepartmentContract.length;
      const countPersonContracts = CheckContractServices.listContracts(
        this.listPersonBasicHeadDepartmentContract,
        this.listBasicHeadDepartmentContract).length;
      if (countPersonContracts === 0) {
        return 100;
      }
      return (100 - (countPersonContracts/(countContracts / 100))).toFixed(2);
    },

    deanBasicProgress() {
      if (!this.effConOrder.dean) return 100
      if (this.listBasicDeanContract.length === 0 && this.listPersonBasicDeanContract.length === 0) return 0

      const countContracts = this.listBasicDeanContract.length;
      const countPersonContracts = CheckContractServices.listContracts(this.listPersonBasicDeanContract, this.listBasicDeanContract).length;
      if (countPersonContracts === 0) {
        return 100;
      }
      return (100 - (countPersonContracts/(countContracts / 100))).toFixed(2);
    },

    statusEffContract() {
      if(!this.effConOrder.is_sent_review) return "Заполнение"
      else {
        const checkedConfirmed = _.filter(this.personEffContracts, (o) => {return o.contract_confirm}).length === this.personEffContracts.length
        if (checkedConfirmed) return "Проверенный"
        else return "Проверяется"
      }
    },

  },

  methods: {

    ...mapActions({
      autoCalculateFactsAction: "effective_contract/autoCalculateFactsAction",
      successSnackbarAction: 'effective_contract_notification_snackbar/successSnackbarAction',
      errorSnackbarAction: 'effective_contract_notification_snackbar/errorSnackbarAction',
    }),

    async autoCalculateFacts() {
      this.loadingBtnCalculate = true;
      try {
        await this.autoCalculateFactsAction();
        await this.successSnackbarAction();
      } catch (err) {
        await this.errorSnackbarAction();
      } finally {
        this.loadingBtnCalculate = false;
      }
    }
  }
}
</script>

<template>
  <v-card
    rounded="xl"
    outlined
  >
    <v-card-title>
      <v-toolbar
        elevation="0"
      >
        <v-toolbar-title v-show="isNotMobile" class="text-h4">
          Эффективный контракт
        </v-toolbar-title>
        <v-spacer/>
        <eff-contract-teacher-action-data-card
          :check-basic-bid-length="checkBasicBid.length"
          :check-basic-dean-length="checkBasicDean.length"
          :check-basic-head-department-length="checkBasicHeadDepartment.length"
          :is-sent-review="effConOrder.is_sent_review"
          :loading-btn-calculate="loadingBtnCalculate"
          @click-send-to-review="showShippingAlert = true"
          @click-auto-calculate="autoCalculateFacts"
        />
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <v-sheet>
        <v-row>
          <v-col cols="12" md="4" lg="2">
            <the-circle-progress-contract
              :bid-basic-progress="Number(bidBasicProgress)"
              :head-department-basic-progress="Number(headDepartmentBasicProgress)"
              :dean-basic-progress="Number(deanBasicProgress)"
            />
          </v-col>
          <v-col cols="12" md="8" lg="4" class="d-flex justify-center flex-column">
            <eff-contract-teacher-data-list
              :surname="dataEmployee.person_surname"
              :name="dataEmployee.person_name"
              :patronymic="dataEmployee.person_patronymic"
              :bid="effConOrder.bid"
              :degree="effConOrder.academic_title"
              :head-department="effConOrder.head_department"
              :dean="effConOrder.dean"
            />
          </v-col>
          <v-col cols="12" lg="6" class="d-flex justify-center flex-column">
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>
    <the-shipping-alert-dialog :visible="showShippingAlert" @close="showShippingAlert = false"/>
  </v-card>
</template>

<style scoped>

</style>